import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import urlParser from 'bloko/common/urlParser';

import {
    DefaultImageWithProfRole,
    Image,
    setDefaultImages,
    setIsGalleryModalVisible,
    setLoadGalleryImages,
    setUserLoadedImages,
} from 'store/models/gallery';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface Params {
    campaignId: string;
    vacancyId: number;
}

interface GalleryImages {
    userLoadedImages: Image[];
    defaultImages: DefaultImageWithProfRole[];
}

type LoadGalleryImages = (fromButton?: boolean) => AppThunkAction<void>;

export const loadGalleryImages: LoadGalleryImages = (fromButton = false) => {
    return (dispatch, getState) => {
        const { bannerVacancyId, campaignIdForBanner } = getState().createBanner;
        dispatch(setLoadGalleryImages(true));
        const params: Partial<Params> = {};
        if (campaignIdForBanner) {
            params.campaignId = campaignIdForBanner;
        }
        if (bannerVacancyId) {
            params.vacancyId = bannerVacancyId;
        }
        const queryStr = urlParser.stringify(params);
        fetcher
            .get<unknown, GalleryImages>(`/api/v1/images/gallery?${queryStr}`)
            .then(({ userLoadedImages, defaultImages }) => {
                dispatch([
                    setUserLoadedImages(userLoadedImages),
                    setDefaultImages(defaultImages),
                    setLoadGalleryImages(false),
                ]);
                if (fromButton) {
                    dispatch(setIsGalleryModalVisible(true));
                }
            })
            .catch(() => {
                dispatch([
                    setUserLoadedImages([]),
                    setDefaultImages([]),
                    setLoadGalleryImages(false),
                    addMagritteNotification(MagritteNotificationName.CampaignFormDefaultImagesError),
                ]);
            });
    };
};
